export default __webpack_public_path__ + "static/media/Screenshot_B3.857a3a84.jpg";